module.exports = __webpack_public_path__ + "static/media/package-1.42a1dc43.jpg";